import tw from 'twin.macro'
import styled from 'styled-components'

export const StyledBlock = tw.div`
  flex px-16 py-12 rounded-12 items-center gap-16
`

export const StyledLabel = tw.div`
  text-14 text-primary font-semibold
`

export const StyledDropdownTrigger = styled.div`
  ${tw`flex px-12 rounded-10 items-center h-[40px] cursor-pointer gradient-violet`}

  :hover {
    background: ${({ theme }) => theme.colors.purple500};
  }

  :hover .arrow-icon {
    fill: ${({ theme }) => theme.colors.text};
  }
`
export const Overlay = tw.div`
  absolute min-h-[110vh] w-[100vw] z-[-1] bg-dark-gray-900 opacity-60 left-0 top-0
`
